'use client'

import type { LucideIcon } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface IconInputProps extends React.ComponentProps<typeof Input> {
	icon: LucideIcon
	trailing?: React.ReactNode
}

export function IconInput({ icon: Icon, trailing, className, ...props }: IconInputProps) {
	return (
		<div className="relative">
			<Icon
				aria-hidden="true"
				className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground"
			/>
			<Input className={cn('h-10 pl-9', trailing && 'pr-10', className)} {...props} />
			{trailing && <div className="absolute top-1/2 right-1.5 -translate-y-1/2">{trailing}</div>}
		</div>
	)
}
